import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSideBarAsanas,
  fetchAsanaById,
} from "../Action/SidebarAsanaAction";

const SideBarAsanaSlice = createSlice({
  name: "sideBarAsana",
  initialState: {
    sideAsanas: [],
    selectedAsana: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSideBarAsanas.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSideBarAsanas.fulfilled, (state, action) => {
        state.loading = false;
        state.sideAsanas = action.payload;
      })
      .addCase(fetchSideBarAsanas.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // ✅ FIX
      })

      .addCase(fetchAsanaById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAsanaById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedAsana = action.payload;
      })
      .addCase(fetchAsanaById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // ✅ FIX
      });
  },
});

export default SideBarAsanaSlice.reducer;
